export default "__VITE_ASSET__DGPRXc_0__"